import React from 'react'
import Header from './components/Header/index'
import Advantage from './components/Advantage/index'
import CooperativeBrand from './components/CooperativeBrand/index'
import CooperativeStar from './components/CooperativeStar/index'
import Footer from './components/Footer/index'
import BrandCase from './components/BrandCase/index'
import EntryConsultation from './components/EntryConsultation/index'

export default function() {
  return (
    <>
      <Header />
      <div id="info-observe-id">
        <Advantage />
        <EntryConsultation />
        <CooperativeBrand />
        <CooperativeStar />
        <BrandCase />
      </div>
      <Footer />
    </>
  )
}
